"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Brendon James",
  position: "Managing Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/team_brendon_james.png",
  linkedin: "#"
}, {
  name: "Sarah Jenkins",
  position: "Operations Manager",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/team_sarah_jenkins.png",
  linkedin: "#"
}];
export default function ThePeopleBehindTheMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="86982" id="leadership" className="bg-background bg-gradient-to-b from-background to-muted/40 py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div ref={ref} className={`flex flex-col items-center text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-serif font-extrabold text-foreground tracking-tighter uppercase mb-6">
            Our Leadership Team
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl">
            Led by industry veterans, our team ensures that every wholesale order meets the highest Australian standards for quality and reliability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {teamMembers.map((member, i) => <div key={member.name} data-index={i} className={`group flex flex-col transition-all duration-1000 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="relative w-full aspect-[3/4] mb-6 overflow-hidden rounded-sm bg-muted shadow-sm">
                <img src={member.image} alt={`Portrait of ${member.name}`} className="object-cover w-full h-full grayscale transition-all duration-700 ease-in-out group-hover:grayscale-0 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 ring-1 ring-inset ring-foreground/10 rounded-sm pointer-events-none group-hover:ring-ring/50 transition-all duration-500"></div>
              </div>
              
              <div className="flex items-start justify-between gap-4 px-1">
                <div>
                  <h3 className="text-xl font-serif font-bold text-foreground mb-1 tracking-tight">
                    {member.name}
                  </h3>
                  <p className="text-secondary font-mono text-xs tracking-widest uppercase">
                    {member.position}
                  </p>
                </div>
                <Link to={member.linkedin} newTab className="text-muted-foreground hover:text-ring transition-colors duration-300 p-2 -mt-2 -mr-2 rounded-sm hover:bg-accent" aria-label={`${member.name}'s LinkedIn profile`}>
                  <Linkedin className="size-5" />
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}